import { Microphone2, Video } from "iconsax-reactjs";
import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { MediaInputManager } from "@/services/mediaInputManager";
import { selectUiModalVisible } from "@/store/features/ui/selectors";
import { toggleUIModal } from "@/store/features/ui/slice";
import { ModalContent } from "@/store/features/ui/types";
import { useAppSelector } from "@/store/hooks";
import { Modal } from "@/ui";
import CameraSelect from "./CameraSelect";
import MicrophoneSelect from "./MicrophoneSelect";
import { StyledSettingsContent, StyledSettingsContentLeft, StyledSettingsContentRight, StyledSettingsTabItem } from "./styled";

enum TabKeys {
  video = 'video',
  audio = 'audio',
};

const tabs = [
  {
    label: 'video',
    icon: <Video size={18} color="var(--color-text)" />,
    key: TabKeys.video,
  },
  {
    label: 'audio',
    icon: <Microphone2 size={18} color="var(--color-text)" />,
    key: TabKeys.audio,
  },
];

const Settings: FC = () => {
  const { t } = useTranslation();

  const prevActive = useRef<TabKeys | ''>('');
  const [active, setActive] = useState<TabKeys | ''>(TabKeys.video);

  const dispatch = useDispatch();
  const isVisible = useAppSelector(selectUiModalVisible(ModalContent.settings));

  useEffect(() => {
    MediaInputManager.onDeviceChange(() => {
      setActive('');
      setTimeout(() => {
        setActive(prevActive.current || TabKeys.video);
      }, 500);
    });
  }, []);

  const onClose = () => {
    dispatch(
      toggleUIModal({
        modal: ModalContent.settings,
        value: false,
      }),
    );
  };

  const onTabChange = (value: TabKeys) => {
    prevActive.current = value;
    setActive(value);
  };

  const renderContent = () => {
    switch (active) {
      case TabKeys.video:
        return <CameraSelect />;
      case TabKeys.audio:
        return <MicrophoneSelect />;
      default:
        return null;
    };
  };

  return (
    <Modal visible={isVisible} title={t('settings')} onClose={onClose} width={696}>
      {isVisible && (
        <StyledSettingsContent>
          <StyledSettingsContentLeft>
            {tabs.map((item) => (
              <StyledSettingsTabItem key={item.key} $active={item.key === active} onClick={() => onTabChange(item.key)}>
                {item.icon}
                {t(item.label)}
              </StyledSettingsTabItem>
            ))}
          </StyledSettingsContentLeft>
          <StyledSettingsContentRight>
            {renderContent()}
          </StyledSettingsContentRight>
        </StyledSettingsContent>
      )}
    </Modal>
  );
};

export default Settings;
